import { useMemo } from "react";

const useEnrichedTeams = ({
  fetchedTeams,
  users,
  branches,
  topics,
  teamLoading,
  userLoading,
  topicLoading,
  branchLoading,
}) => {
  const teams = useMemo(() => {
    if (
      !fetchedTeams?.length ||
      !users?.length ||
      !branches?.length ||
      !topics?.length
    )
      return [];

    const usersMap = new Map(users?.map((u) => [u.id, u]));
    const branchesMap = new Map(branches?.map((b) => [b.id, b]));
    const topicsMap = new Map(topics?.map((t) => [t.id, t]));

    return fetchedTeams.map((team) => {
      let teamLead = null;

      const teamUsers = team?.team_members.map((member) => {
        const user = usersMap.get(member.user_id) || {};

        if (member.role === "Team Leader") {
          teamLead = user;
        }

        return {
          ...user,
          ...member,
        };
      });

      return {
        ...team,
        users: teamUsers,
        teamLead: teamLead || teamUsers[0],
        branch: branchesMap?.get(team.branch_id) || null,
        topics: team?.topic_ids?.map((id) => topicsMap.get(id)).filter(Boolean),
      };
    });
  }, [fetchedTeams, users, branches, topics]);

  const isLoading = useMemo(() => {
    return teamLoading || userLoading || topicLoading || branchLoading;
  }, [teamLoading, userLoading, topicLoading, branchLoading]);

  return { teams, isLoading };
};

export default useEnrichedTeams;
